import UtilService from "../UtilServices";
import TimedCompanionExtension from "./extensionTimeSet";
import {TrackJS} from 'trackjs';

export default class KioskStrictVerificator {
static verifyKiosk = async (payload: { methodName: string }, pwaAppToken: string, kioskExtensionId: string = "") => {
    let response;
    try {
        const res = await TimedCompanionExtension.waitForMessageOrGiveUp(chrome.runtime.sendMessage(kioskExtensionId, payload), 30000);
        if ((res?.challengeResponse && res?.type === "challenge_response_ready")) {
            response = { challengeResponse: res?.challengeResponse, pwaAppToken };
        } else {
            console.error('Unable to timely produce a valid challenge via the Kiosk Verificator Companion Extension.', res, pwaAppToken)
            if(res?.errors) {
                response = { error: ["KIOSK_VERIFICATOR_ERROR_IN_EXTENSION"], pwaAppToken };
            } else {
                response = { error: ["NON_KIOSK_MODE"] }
            }
        }
    }
    catch (error) {
        console.error('Unable to get a valid response from Kiosk Verificator', error, pwaAppToken);
        response = { error: ["KIOSK_VERIFICATOR_ERROR_IN_EXTENSION"], pwaAppToken };
    }

    return response;
}

static produceChallengeOrGiveUp = async () => {
    let response;
    const pwaAppToken = UtilService.generatePwaAppToken();
    TrackJS.addMetadata("pwaAppToken", pwaAppToken);

    const payload = { methodName: 'start_kiosk_verification' };
    const kioskExtensionId = process.env.REACT_APP_KIOSK_MODE_VERIFICATOR_EXTENSION_ID;

    let res;
    try {
        res = await (navigator as any)?.managed?.getManagedConfiguration(['kiosk_checker']);
    } catch (error) {
        console.log('Managed config is not setup for institution.', error, pwaAppToken);
        return { error: ["MANAGED_DEVICE_CONFIGURATION_UNAVAILABLE"], pwaAppToken };
    }

    try {
        if (!window.chrome?.runtime || !res?.kiosk_checker?.includes('verified_access')) {
            console.debug('Chrome Verificator has not been activated for institution. Using direct whitelisting.', pwaAppToken, res?.kiosk_checker);
            response = { error: ["KIOSK_VERIFICATOR_NOT_AVAILABLE_FOR_MANAGED_DEVICE"], pwaAppToken };
        } else {
            response = await KioskStrictVerificator.verifyKiosk(payload, pwaAppToken, kioskExtensionId);
        }
    } catch (error) {
        console.error('Kiosk verification failed with manage config.', error, pwaAppToken);
        response = { error: ["KIOSK_VERIFICATOR_ERROR_IN_EXTENSION"], pwaAppToken }
    }
    return response
}

}